import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';
import axios from 'axios';
import qs from 'qs';
import vmodal from 'vue-js-modal';
import 'vue-popperjs/dist/vue-popper.css';
import VueClipboard from 'vue-clipboard2';

import slugify from '@/slugify';
import App from './App.vue';
import List from './VendorList.vue';
import ConnectList from './ConnectList.vue';
import VendorCompare from './VendorCompare.vue';
import VendorDetail from './VendorDetail.vue';
import ConnectCompare from './ConnectCompare.vue';
import ConnectDetail from './ConnectDetail.vue';
import AdminHome from './AdminHome.vue';
import AdminCap from './AdminCap.vue';
import ConnectEnquiries from './ConnectEnquiries.vue';


Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(Router);
Vue.use(vmodal);
Vue.use(VueClipboard);
Vue.mixin({ methods: { toSlug: slugify.toSlug } });


const store = new Vuex.Store({
  state: {
    refMap: null,
    // verticals, {code: {code, label}}
    // vertical_items, [Vertical.keys]
    // tech_areas code -> {'code': code, 'label': name, 'items': []}
    // techs_items [{id}] // each item is an object, for TreeFilter with group
    // technologies {id: {id, label}}
    // connectTech {code: bool} // if true wont be disabled

    // filters
    terms: [], // filterTerms
    verticals: {}, // id -> bool filter
    techs: {}, // id -> bool filter

    page: { count: null, currentPage: null, totalPages: null },
    compare: {}, // Vendor.id -> bool
  },

  getters: {
    getSelectedTech(state) {
      // return filters as array
      const result = [];
      for (const key in state.techs) {
        if (state.techs[key]) {
          result.push(key);
        }
      }
      return result;
    },
    getSelectedVert(state) {
      // return filters as array
      const result = [];
      for (const key in state.verticals) {
        if (state.verticals[key]) {
          result.push(key);
        }
      }
      return result;
    },
    getTechKeys(state) {
      // for TreeFilter WITHOUT groups
      const keys = [];
      for (const tech of state.refMap.tech_items) {
        keys.push(tech.id);
      }
      return keys;
    },
  },

  mutations: {
    initMaps(state, payload) {
      state.refMap = payload;
    },

    setTerms(state, payload) {
      state.terms = payload;
    },

    setFilter(state, payload) {
      if (payload.val === null) {
        state[payload.property] = {};
      } else {
        Vue.set(state[payload.property], payload.id, payload.val);
      }
    },

    resetFilter(state, payload) {
      // user for select component
      state[payload.property] = { [payload.id]: payload.val };
    },

    setTechGroup(state, payload) {
      for (const itemId of state.refMap.tech_areas[payload.groupCode].items) {
        Vue.set(state.techs, itemId, payload.val);
      }
    },

    setPage(state, payload) {
      state.page = payload;
    },

    toggleCompare(state, payload) {
      const current = payload.id in state.compare;
      if (current) {
        Vue.delete(state.compare, payload.id);
      } else {
        Vue.set(state.compare, payload.id, payload.val);
      }
    },
  },
});


const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '' : '/vd',
  routes: [
    {
      path: '/research/vendors',
      name: 'vendor-list',
      component: List,
    },
    {
      path: '/research/vendors/compare',
      name: 'vendor-compare',
      component: VendorCompare,
    },
    {
      path: '/research/vendors/:id/:slug?',
      name: 'vendor-detail',
      component: VendorDetail,
    },

    // only for Connect
    {
      path: '/vendor-connect',
      name: 'connect-list',
      component: ConnectList,
    },
    {
      path: '/vendor-connect/compare',
      name: 'connect-compare',
      component: ConnectCompare,
    },
    {
      path: '/vendor-connect/admin/:id',
      name: 'admin-home',
      component: AdminHome,
    },
    {
      path: '/vendor-connect/admin/:id/baseline',
      name: 'admin-baseline',
      component: AdminCap,
      props: { kind: 'baseline' },
    },
    {
      path: '/vendor-connect/admin/:id/tech/:code',
      name: 'admin-tech',
      component: AdminCap,
      props: { kind: 'tech' },
    },
    {
      path: '/vendor-connect/admin/:id/vert/:code',
      name: 'admin-vert',
      component: AdminCap,
      props: { kind: 'vert' },
    },
    {
      path: '/vendor-connect/admin/:id/sp/:code',
      name: 'admin-sp',
      component: AdminCap,
      props: { kind: 'sp' },
    },
    {
      path: '/vendor-connect/admin/:id/enquiries',
      name: 'admin-enquiries',
      component: ConnectEnquiries,
    },
    {
      path: '/vendor-connect/:id/:slug?',
      name: 'connect-detail',
      component: ConnectDetail,
    },
  ],
});


Vue.mixin({
  methods: {
    verticalTitle(code) {
      if (code === null) {
        return 'All Sectors';
      }
      return this.$store.state.refMap.verticals[code].label;
    },
    techTitle(code) {
      if (code === null) {
        return 'All Technologies';
      }
      const tech = {
        '3P': '3D Printing and Additive Manufacturing',
        AI: 'Artificial Intelligence',
        AV: 'Autonomous Robotic Systems',
        DS: 'Data Sharing',
        DL: 'Distributed Ledger',
        EC: 'Edge Computing',
        FT: 'Future Technologies',
        HM: 'Human Machine Interface',
        HC: 'Hyperconnectivity',
        IT: 'Internet of Things',
        PL: 'Product Lifecycle Management',
        RP: 'Robotic Process Automation',
      };
      return tech[code];
    },
  },
});


const axiosInstance = axios.create({
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
});
Vue.prototype.$axios = axiosInstance;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
